import type { Row } from '../../../core/view-manager/row.js';
import type { GanttSingleView } from '../gantt-view-manager.js';
import type { DependencyGraph } from './cycle-detector.js';

/**
 * Builds an adjacency-list dependency graph from the configured Relation
 * column. The graph is directional (`A → B` means A blocks B).
 *
 * Only rows currently visible in the view are indexed — the caller is
 * responsible for passing the filtered row list.
 */
export function buildDependencyGraph(
  view: GanttSingleView,
  rows: readonly Row[]
): DependencyGraph {
  const depsCol = view.dependenciesCol$.value;
  if (!depsCol) return new Map();

  const graph = new Map<string, Set<string>>();

  for (const row of rows) {
    const cell = view.cellGetOrCreate(row.rowId, depsCol);
    const raw = cell.jsonValue$.value;
    if (!Array.isArray(raw)) continue;

    const targets = new Set<string>();
    for (const target of raw) {
      if (typeof target === 'string' && target !== row.rowId) {
        targets.add(target);
      }
    }
    if (targets.size > 0) {
      graph.set(row.rowId, targets);
    }
  }

  return graph;
}
